module.exports = __webpack_public_path__ + "img/services-defalut.a54df20e.svg";